import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import * as XLSX from 'xlsx';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule, DatePipe, DecimalPipe, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {environment} from '@env/environment';
import numberToWords from 'number-to-words';
import {Nl2BrPipe} from '@app/shared/pipe';
import {UtilsInjectable} from '@app/shared';


const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-sales-vat-report',
  templateUrl: './sales-vat-report.component.html',
  imports: [
    CommonModule,
    DecimalPipe,
    FormsModule,
    PageHeaderComponent,
    DatePipe,
    Nl2BrPipe,
    NgOptimizedImage
  ],
  styleUrls: ['./sales-vat-report.component.scss']
})
export class SalesVatReportComponent implements OnInit {

  @ViewChild('table') table?: ElementRef;
  user_rights: any;
  user_data: any;

  stock_data: any;
  closeResult = "";
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = new Date();
  todate = new Date();
  start: any;
  limit: any;

  states: any[] = [];
  state_options: any[] = [];
  vat_state: any;
  vat_statecode: any;
  state_data: any;
  vat_total = 0;
  flood = 0;
  total_exclude = 0;
  total_include = 0;
  item_list: any;
  save_rate = 0;
  gross = 0;
  saled: any;
  price_total = 0;
  numberToWords: any;
  vat_list: any;
  total_vat = 0;
  total_flood = 0;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  configer = {
    displayKey: "STATE_NAME",
    search: true,
    height: 'auto',
    placeholder: 'Select State',

    limitTo: 10,
    moreText: '.........',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'STATE_NAME'
  }

  constructor(
    private loaderService: LoaderService,
    private modalService: NgbModal,
    public rest: ConsultingService,
    public report: ReportService,
    protected utils: UtilsInjectable
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.fromdate = new Date(this.fromdate.getFullYear(), this.fromdate.getMonth(), 1, 23, 59, 59);
    this.todate = new Date(this.todate.getFullYear(), this.todate.getMonth() + 1, 0, 23, 59, 59);
    this.listState();
    this.listVATReport();
  }

  public ExportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table?.nativeElement, {
      dateNF: 'dd/mm/yyyy;@',
      cellDates: true,
      raw: true
    });
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'Sale_vat_report_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listVATReport() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.listVatsaleReport(postData).subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.stock_data = result['data'];
        this.BalVatamount();
        this.loaderService.display(false);
      } else {
        this.stock_data = []
        this.vat_total = 0
        this.flood = 0
        this.total_exclude = 0
        this.total_include = 0
        this.loaderService.display(false);
      }
    });
  }

  getSum() {
    let total = 0;
    let save = 0;
    for (const item of this.item_list) {
      total = total + parseFloat(item.TOTAL);
      save = save + parseFloat(item.SAVE_RATE);
    }
    this.save_rate = Math.round(save);
    this.gross = total
    if (this.saled) {

      this.price_total = Math.round((this.gross - parseFloat(this.saled.DISCOUNT)) + parseFloat(this.saled.FREIGHT_CHARGE))
    } else {
      this.price_total = Math.round(this.gross)
    }

    this.numberToWords = (numberToWords.toWords(this.price_total));
  }

  public getVatValue() {
    const postData = {
      sale_id: this.saled.SALE_ID,
      state_code: this.saled.TIN_NUMBER
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.getVatValue(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.vat_list = result['data'];
        let total_vat = 0;
        let total_flood = 0;
        for (const vat of this.vat_list) {
          total_vat = total_vat + parseFloat(vat.VAT_VALUE)
          total_flood = total_flood + parseFloat(vat.FLOOD_CESS)
        }
        this.total_vat = (total_vat)
        this.total_flood = (total_flood)
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public sale_items(item: any): any {
    const postData = {
      sale_id: item
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.getSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.item_list = result['data'].SALE;
        let i = 0;
        for (const data of this.item_list) {

          const unit = parseFloat(data.UNIT_PRICE);
          const vat = parseFloat(data.VAT);
          if (this.saled && this.saled.TIN_NUMBER == 32) {
            data["BASE_PRICE"] = ((unit / (environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          if (this.saled && this.saled.TIN_NUMBER != 32) {
            data["BASE_PRICE"] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          this.item_list[i] = data;
          i = i + 1;
        }
        this.getVatValue();
        this.getSum();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public BalVatamount() {
    let i = 0
    let vat_total = 0;
    let total_exclude = 0;
    let total_include = 0;
    let flood = 0;
    for (const data of this.stock_data) {
      vat_total = vat_total + parseFloat(data.SALE_VAT_AMOUNT)
      flood = flood + parseFloat(data.FLOOD_CESS)
      total_exclude = total_exclude + parseFloat(data.TOTAL_EXCLUDE_VAT)
      total_include = total_include + parseFloat(data.TOTAL_INCLUDE_VAT)
      i = i + 1;
    }
    this.vat_total = (vat_total)
    this.flood = (flood)
    this.total_exclude = (total_exclude)
    this.total_include = (total_include)
  }

  public listState() {
    this.states = [];
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.listState().subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.states = result['state']['data'];
        this.state_options = this.states;
        this.vat_state = this.state_options[18].STATE_ID;
        this.vat_statecode = this.state_options[18].TIN_NUMBER;
        this.setState();

        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);

      }
    });
  }

  public setState() {
    if (this.vat_state) {
      for (let index = 0; index < this.states.length; index++) {
        if (this.states[index].STATE_ID == this.vat_state) {
          this.state_data = this.states[index];
          break;
        }
      }
    }
  }

  protected opens(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
